/* eslint import/no-webpack-loader-syntax: off */
import LightTheme from "!!raw-loader!./styles/app-modern.min.css";
import DarkTheme from "!raw-loader!./styles/app-modern-dark.min.css";
import ResponsiveStyle from "!raw-loader!./styles/responsive.css";
import AppStyles from "!raw-loader!./styles/style.css";
import StyleWizard from "!raw-loader!./styles/style_wizard.css";
import { fetchUser } from "@mobile-dev/platform/common/redux/actions/AmplifyUserAction";
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route, Switch } from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';
import DriverMobile from "./Components/Carrier/DriverMobile";
import CaptchaVerifications from "./Components/Common/Captcha/CaptchaVerifications";
import TransactionDialog from './Components/Common/TransactionDialog';
import Help from './Components/Content/Help/Help';
import BillingDetails from './Components/Content/Payments/Billed/BillingDetails';
import PaymentCompleted from './Components/Content/Payments/Billed/PaymentCompleted';
import PaymentConfirmation from './Components/Content/Payments/Billed/PaymentConfirmation';
import PaymentDetails from './Components/Content/Payments/Billed/PaymentDetails';
import ComCheckPayment from './Components/Content/Payments/Billed/PaymentMethods/ComCheckPayment';
import CreditCard from './Components/Content/Payments/Billed/PaymentMethods/CreditCard';
import EFS from "./Components/Content/Payments/Billed/PaymentMethods/EFS";
import InstaMoney from "./Components/Content/Payments/Billed/PaymentMethods/InstaMoney";
import RelayPayment from './Components/Content/Payments/Billed/PaymentMethods/RelayPayment';
import TCheck from "./Components/Content/Payments/Billed/PaymentMethods/TCheck";
import UsBank from "./Components/Content/Payments/Billed/PaymentMethods/UsBank";
import SelectPayment from './Components/Content/Payments/Billed/SelectPayment';
import TransactionUnsuccessfull from './Components/Content/Payments/Billed/TransactionUnsuccessfull';
import CompletedDetails from './Components/Content/Payments/Completed/CompletedDetails';
import LoadStatus from './Components/Content/Payments/LoadStatus/LoadStatus';
import UnbilledDetails from './Components/Content/Payments/UnBilled/UnbilledDetails';
import ErrorBoundary from './Components/ErrorBoundary/ErrorBoundary';
import ForgotPassword from "./Components/ForgotPassword/ForgotPassword";
import ResetPassword from "./Components/ForgotPassword/ResetPassword";
import LandingPage from "./Components/LandingPage/LandingPage";
import CarrierLogin from "./Components/Login/CarrierLogin";
import Login from './Components/Login/Login';
import Navbar from './Components/Navbar/Navbar';
import OtpScreen from './Components/Otp/OtpScreen';
import EditProfile from './Components/Profile/EditProfile';
import ProfileInfo from './Components/Profile/ProfileInfo';
import Sidebar from './Components/Sidebar/Sidebar';
import Signup from './Components/Signup/Signup';
import { AppConstatnt } from './Utils/AppConstant';
import { getTheme, setTheme, showAlert } from './Utils/Utility';
import { fsInterceptor } from '@mobile-dev/platform/common/api/Interceptor';
import NewPaymentDetails from "./Components/Content/Payments/Billed/NewPaymentDetails";

import LiveSupport from './Components/Content/Help/LiveSupport';




function PrivateRoute({ children, ...rest }) {
  const user = useSelector(state => state.login.captchaResponse);
  const carrierData = useSelector(state => state.carrierLogin);
  const dispatch = useDispatch();
  const auth = useSelector(state => state.amplifyUser);

  useEffect(() => {
    dispatch(fetchUser());
    fsInterceptor(process.env.REACT_APP_API_KEY)
  }, []);

  if (!navigator.onLine) showAlert(toast.TYPE.ERROR, 'You are offline! , Please connect to internet.');

  return (
    <Route
      {...rest}
      render={({ location }) =>
        user || carrierData?.session ? (children) :
          (
            <Redirect to={{
              pathname: "/home",
              state: { from: location }
            }}
            />
          )
      }
    />
  );
}

function App() {
    const auth = useSelector(state => state.amplifyUser);
    const userData = auth.user?.attributes;
  const [darkTheme, setDarkTheme] = useState(true);


  useEffect(() => {

    const val = getTheme();
    const theme = val === AppConstatnt.theme.DARK ? true : false;
    setDarkTheme(theme);
  }, []);

  function changeTheme(val) {
    setDarkTheme(val);
    const theme = val === true ? AppConstatnt.theme.DARK : AppConstatnt.theme.LIGHT;
    setTheme(theme);
  }

  return (
    <ErrorBoundary>

      <ToastContainer
        theme={darkTheme ? 'dark' : 'light'}
        position={toast.POSITION.TOP_RIGHT}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
      />
      <Switch>
        <Route exact path='/home' component={LandingPage} />
        <Route exact path='/signin' component={Login} />
        <Route exact path='/signup' component={Signup} />
        <Route exact path='/Otp' component={OtpScreen} />
        <Route exact path='/carrierLogin' component={CarrierLogin} />
        <Route exact path='/driverMobile' component={DriverMobile} />
        <Route exact path='/forgotpassword' component={ForgotPassword} />
        <Route exact path='/resetPassword' component={ResetPassword} />
        <Route exact path='/captcha' component={CaptchaVerifications} />

        <PrivateRoute>
          <Navbar isDarkThemeActive={darkTheme} changeTheme={changeTheme} />
          <div className="container-fluid mm-active">
            <div className="wrapper mm-show">
              <Sidebar userData={userData}/>
              <Route exact path='/' component={LoadStatus} />
              <Route exact path='/help' component={Help} />
              <Route exact path='/liveSupport' component={LiveSupport} />
              <Route exact path='/billedDetails/:id' component={BillingDetails} />
              <Route exact path='/unbilledDetails/:id' component={UnbilledDetails} />
              <Route exact path='/completedDetails/:id' component={CompletedDetails} />
              <Route exact path='/paymentconfirmation/:id' component={PaymentConfirmation} />
              <Route exact path='/profile' component={ProfileInfo} />
              <Route exact path='/edit' component={EditProfile} />
              <Route exact path='/paymentDetails/:id' component={PaymentDetails} />
              <Route exact path='/newpaymentDetails/:id' component={NewPaymentDetails} />
              <Route exact path='/selectPayment/:id' component={SelectPayment} />
              <Route exact path='/creditcard/:id' component={CreditCard} />
              <Route exact path='/relay/:id' component={RelayPayment} />
              <Route exact path='/comCheck/:id' component={ComCheckPayment} />
              <Route exact path='/success/:id' component={TransactionDialog} />
              <Route exact path='/paymentcompleted/:id' component={PaymentCompleted} />
              <Route exact path='/usBank/:id' component={UsBank} />
              <Route exact path='/instaMoney/:id' component={InstaMoney} />
              <Route exact path='/efs/:id' component={EFS} />
              <Route exact path='/tCheck/:id' component={TCheck} />
              <Route exact path='/transactionUnsuccessfull/:id' component={TransactionUnsuccessfull} />
            </div>
          </div>
        </PrivateRoute>

      </Switch>
      <Helmet>
        <style>{darkTheme ? DarkTheme : LightTheme}</style>
        <style>{ResponsiveStyle}</style>
        <style>{StyleWizard}</style>
        <style>{AppStyles}</style>
      </Helmet>
    </ErrorBoundary>
  );
}

export default App;
